const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export function getPublicInvoiceToken(routeToken, search = '') {
  const token = routeToken || new URLSearchParams(search).get('token');
  return typeof token === 'string' && UUID.test(token) ? token : null;
}

export function legacyInvoiceRedirect(hash) {
  // Support already-emailed hash links without redirecting arbitrary URLs.
  const match = /^#(\/invoice\/public(?:\/([0-9a-f-]+))?)(\?[^#]*)?$/i.exec(hash || '');
  if (!match) return null;
  const search = new URLSearchParams(match[3] || '');
  const token = getPublicInvoiceToken(match[2], search.toString());
  if (!token) return null;
  return `/invoice/public/${token}${search.get('download') === '1' ? '?download=1' : ''}`;
}
